import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Sanitizes error messages for user display.
 * Filters out technical/developer errors and returns user-friendly messages.
 */
export function sanitizeErrorMessage(error: any, fallback = "Something went wrong. Please try again."): string {
  const message = error?.message || error?.toString() || "";

  // Patterns that indicate technical/developer errors that shouldn't be shown to users
  const technicalPatterns = [
    /requires.*index/i,
    /firestore.*index/i,
    /missing.*index/i,
    /FAILED_PRECONDITION/i,
    /permission.*denied/i,
    /quota.*exceeded/i,
    /internal.*error/i,
    /network.*error/i,
    /firebase.*internal/i,
    /grpc/i,
    /deadline.*exceeded/i,
    /unavailable/i,
    /resource.*exhausted/i,
    /cancelled/i,
    /unknown.*error/i,
    /failed.*fetch/i,
    /cors/i,
    /aborted/i,
  ];

  // Check if it's a technical error
  const isTechnicalError = technicalPatterns.some(pattern => pattern.test(message));

  if (isTechnicalError) {
    console.warn("Technical error hidden from user:", message);
    return fallback;
  }

  // Return cleaned message or fallback
  return message || fallback;
}
